import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";

import AssetTableComponent from "./asset-table.component";
import TableSort from "../../../../../shared/helpers/table-sort";
import capitalizeFirst from "../../../../../shared/helpers/upper-case";
import { useQuery } from "@tanstack/react-query";
import { getAssets } from "../../../../../core/api/services/asset.service";
import GlobalOverlays from "src/core/components/global-overlays/global-overlays.component";

const AssetComponent = () => {
  const [pageNumber, setPageNum] = useState<number>(1);
  const [assetSearchValue, setAssetSearchValue] = useState("");
  const [filters, setFilters] = useState<any>({});
  const pageSize = 10;

  const filter = useSelector((state: any) => {
    return state.asset.assetsFilter;
  });

  const [sortBy, setSortBy] = useState<any>(capitalizeFirst("lastOnline"));
  const [sortDirection, setSortDirection] = useState<any>("DESC");

  const [columns, setColumns] = useState([
    {
      title: "Asset ID ",
      label: "assetCode",
      type: "link",
      link: "/asset",
      linkableField: "assetCode",
      isOpenInNewTable: true,
    },

    {
      title: "Display Name",
      label: "assetDisplayName",
    },
    {
      title: "Last Heartbeat",
      label: "lastOnline",
      type: "datetime",
      isSorted: true,
    },
    {
      title: "Address",
      label: "address",
    },
    {
      title: "Registration Date",
      label: "registrationDate",
      type: "datetime",
    },
  ]);

  useEffect(() => {
    setPageNum(1);
    setFilters(filter);
  }, [filter]);

  const {
    data: assets,
    isLoading: isLoadingAssets,
    refetch,
  } = useQuery({
    queryKey: [
      "getAssets",
      pageNumber,
      filters?.townCouncil,
      filters?.site,
      filters?.block,
      filters?.isActive,
      filters?.status,
      filters?.assetTypeId,
      sortBy,
      sortDirection,
      assetSearchValue,
    ],
    queryFn: ({ signal }) =>
      getAssets(
        pageNumber,
        pageSize,
        filters?.townCouncil,
        filters?.site,
        filters?.block,
        filters?.isActive,
        filters?.status,
        filters?.assetTypeId,
        sortBy,
        sortDirection,
        assetSearchValue,
        signal
      ),
  });

  const onRefetchData = () => {
    if (assets?.numberOfRecords <= pageSize + 1) {
      setPageNum(1);
    }
    refetch();
  };

  const handleChangePage = useCallback((page: number): void => {
    setPageNum(page);
  }, []);

  const handleChangeSort = useCallback(
    async (sortBy: string, sortDirection: any) => {
      if (!sortBy || !sortDirection) return;
      setSortBy(sortBy);
      setSortDirection(sortDirection);

      const copyColumns: any = await TableSort(columns, sortBy);
      setColumns(copyColumns);
    },
    []
  );

  const handleSearch = useCallback((searchVal: string): void => {
    setPageNum(1);
    setAssetSearchValue(searchVal);
  }, []);

  return (
    <>
      <div>
        <AssetTableComponent
          columns={columns}
          data={assets?.data}
          totalNumberOfRecords={assets?.numberOfRecords}
          pageSize={pageSize}
          current={pageNumber}
          onChangePage={handleChangePage}
          onRefetchData={onRefetchData}
          onChangeSort={handleChangeSort}
          isLoading={isLoadingAssets}
          onSearch={handleSearch}
          filter={filter}
          assetSearchValue={assetSearchValue}
          sortBy={sortBy}
          sortDirection={sortDirection}
        />
      </div>
      <GlobalOverlays />
    </>
  );
};

export default AssetComponent;
